const footer = {
  company: {
    payoff: 'Fondazione AIRC <br/> per la ricerca sul cancro ETS',
    description: 'Copyright ©2000-2025 - Viale Isonzo 25, 20135 Milano',
  },
}

export default footer
